<template>
  <base-modal
    ref="core"
    :nested="false"
  >
    <template #header>
      <h4>{{ $t('components.vehicles.modals.editVehicle') }}</h4>
    </template>

    <template #body>
      <div
        class="form-horizontal"
        role="form"
      >
        <div class="form-body">
          <div class="form-group">
            <div class="row">
              <div class="col-md-6">
                <label class="control-label">{{ $t('components.vehicles.modals.registration') }}</label>
                <input
                  v-model="v.vehicle.registration.$model"
                  :class="{ 'custom-error': v.vehicle.registration.$error }"
                  class="form-control input-sm"
                  placeholder="CBY 2A561"
                  type="text"
                >
                <div
                  v-for="error of v.vehicle.registration.$errors"
                  :key="error.$uid"
                  class="vuelidate-errors"
                >
                  <p class="error-msg">
                    {{ error.$message }}
                  </p>
                </div>
              </div>

              <div class="col-md-6">
                <label class="control-label">{{ $t('components.vehicles.modals.name') }}</label>
                <input
                  v-model="v.vehicle.vars.name.$model"
                  :class="{ 'custom-error': v.vehicle.vars.name.$error }"
                  class="form-control input-sm"
                  placeholder="Scania V8"
                  type="text"
                >
                <div
                  v-for="error of v.vehicle.vars.name.$errors"
                  :key="error.$uid"
                  class="vuelidate-errors"
                >
                  <p class="error-msg">
                    {{ error.$message }}
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <label class="control-label">{{ $t('components.vehicles.modals.vinNumber') }}</label>
                <input
                  v-model="v.vehicle.vin.$model"
                  :class="{ 'custom-error': v.vehicle.vin.$error }"
                  class="form-control input-sm"
                  placeholder="ABCD1234567890246"
                  type="text"
                >
                <div
                  v-for="error of v.vehicle.vin.$errors"
                  :key="error.$uid"
                  class="vuelidate-errors"
                >
                  <p class="error-msg">
                    {{ error.$message }}
                  </p>
                </div>
              </div>

              <div class="col-md-6">
                <label class="control-label">{{ $t('components.vehicles.modals.driver') }}</label>
                <vue-select
                  v-model="v.vehicle.driver.$model"
                  :class="{ 'custom-error': v.vehicle.driver.$error }"
                  :options="drivers"
                  :value="selectedDriver"
                  class="flex-grow vue-select"
                  icon="bi bi-person-fill"
                  label="name"
                  @updateSelect="getDriver"
                />
                <div
                  v-for="error of v.vehicle.driver.$errors"
                  :key="error.$uid"
                  class="vuelidate-errors"
                >
                  <p class="error-msg">
                    {{ error.$message }}
                  </p>
                </div>
              </div>
              <div class="col-md-6">
                <label class="control-label">{{ $t('components.vehicles.modals.phone') }}</label>
                <input
                  v-model="v.vehicle.vars.phone.$model"
                  :class="{ 'custom-error': v.vehicle.vars.phone.$error }"
                  class="form-control input-sm"
                  placeholder="+48 508 509 123"
                  type="text"
                >
                <div
                  v-for="error of v.vehicle.vars.phone.$errors"
                  :key="error.$uid"
                  class="vuelidate-errors"
                >
                  <p class="error-msg">
                    {{ error.$message }}
                  </p>
                </div>
              </div>

              <div class="col-md-6">
                <label class="control-label">{{ $t('components.vehicles.modals.virtualOdometer') }}</label>
                <input
                  v-model="v.vehicle.vars.virtual_odometer.$model"
                  :class="{ 'custom-error': v.vehicle.vars.virtual_odometer.$error }"
                  class="form-control input-sm"
                  placeholder="500000"
                  type="number"
                >
                <div
                  v-for="error of v.vehicle.vars.virtual_odometer.$errors"
                  :key="error.$uid"
                  class="vuelidate-errors"
                >
                  <p class="error-msg">
                    {{ error.$message }}
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="control-label">{{ $t('components.vehicles.modals.visibleOnMap') }}</label>
                <div>
                  <input
                    v-model="vehicle.vars.visible"
                    type="checkbox"
                  >
                </div>
              </div>
              <div class="col-md-6">
                <label class="control-label">{{ $t('components.vehicles.dataGrids.etoll') }}</label>
                <div>
                  <input
                    type="checkbox"
                    v-model="vehicle.device.etoll"
                    :true-value="true"
                    :false-value="false"
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <label class="control-label">{{ $t('components.vehicles.modals.iconOnMap') }}</label>
                <div class="d-flex flex-wrap gap-2">
                  <label
                    v-for="icon in icons"
                    :key="icon.id"
                    class="icon-radio"
                  >
                    <input
                      class="invisible"
                      type="radio"
                      v-model.number="vehicle.vars.icon_id"
                      :value="icon.id"
                    >
                    <img
                      :src="icon.src"
                      :alt="`icon ${icon.id}`"
                      class="icon-thumb"
                    >
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div
              class="container-fluid"
              style="border: 1px dashed #808080;padding:15px;"
            >
              <div class="row">
                <div class="col-md-12 mb-3">
                  <h5>{{ $t('components.vehicles.modals.tankHeadline') }}</h5>
                </div>
                <div class="col-md-6">
                  <label class="control-label">{{ $t('components.vehicles.modals.tankCapacity') }} 1 (L)</label>
                  <input
                    v-model="v.vehicle.tank_capacity.$model"
                    :class="{ 'custom-error': v.vehicle.tank_capacity.$error }"
                    class="form-control input-sm input_tank"
                    placeholder="600"
                    type="number"
                  >
                  <div
                    v-for="error of v.vehicle.tank_capacity.$errors"
                    :key="error.$uid"
                    class="vuelidate-errors"
                  >
                    <p class="error-msg">
                      {{ error.$message }}
                    </p>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="control-label">{{ $t('components.vehicles.modals.tankCapacity') }} 2 (L)</label>
                  <input
                    v-model="v.vehicle.tank_capacity2.$model"
                    :class="{ 'custom-error': v.vehicle.tank_capacity2.$error }"
                    class="form-control input-sm input_tank"
                    placeholder="600"
                    type="number"
                  >
                  <div
                    v-for="error of v.vehicle.tank_capacity2.$errors"
                    :key="error.$uid"
                    class="vuelidate-errors"
                  >
                    <p class="error-msg">
                      {{ error.$message }}
                    </p>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="control-label">{{ $t('components.vehicles.modals.tankCapacity') }} Ad-Blue (L)</label>
                  <input
                    v-model="v.vehicle.tank_ad_blue.$model"
                    :class="{ 'custom-error': v.vehicle.tank_ad_blue.$error }"
                    class="form-control input-sm"
                    placeholder="600"
                    type="number"
                  >
                  <div
                    v-for="error of v.vehicle.tank_ad_blue.$errors"
                    :key="error.$uid"
                    class="vuelidate-errors"
                  >
                    <p class="error-msg">
                      {{ error.$message }}
                    </p>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="control-label">{{ $t('components.vehicles.modals.tankCapacity') }} LNG (L)</label>
                  <input
                    v-model="v.vehicle.tank_lng.$model"
                    :class="{ 'custom-error': v.vehicle.tank_lng.$error }"
                    class="form-control input-sm"
                    placeholder="600"
                    type="number"
                  >
                  <div
                    v-for="error of v.vehicle.tank_lng.$errors"
                    :key="error.$uid"
                    class="vuelidate-errors"
                  >
                    <p class="error-msg">
                      {{ error.$message }}
                    </p>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="control-label">{{ $t('components.vehicles.modals.tankCapacity') }} KWh</label>
                  <input
                    v-model="v.vehicle.tank_kwh.$model"
                    :class="{ 'custom-error': v.vehicle.tank_kwh.$error }"
                    class="form-control input-sm"
                    placeholder="600"
                    type="number"
                  >
                  <div
                    v-for="error of v.vehicle.tank_kwh.$errors"
                    :key="error.$uid"
                    class="vuelidate-errors"
                  >
                    <p class="error-msg">
                      {{ error.$message }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #footer>
      <div class="pull-right">
        <button
          class="btn btn-default"
          @click="closeModal"
        >
          <i class="fa fa-remove" />
          {{ $t('components.vehicles.modals.exit') }}
        </button>
        <button
          class="btn btn-primary"
          @click="editVehicle"
        >
          <i class="fa fa-save" />
          {{ $t('components.vehicles.modals.save') }}
        </button>
      </div>
    </template>
  </base-modal>
</template>

<script lang="ts">
import BaseModal from './core/BaseModal.vue'

import { defineComponent } from 'vue'
import useVuelidate from '@vuelidate/core'
import { required } from '@/vuelidate/i18n-validators'
import VueSelect from '@/components/extras/VueSelect.vue'
import { axiosInstance } from '@/http-common'
import { getUsers } from '@/crud/getters'

function editVehicle() {
  return {
    registration: '',
    tank_capacity: 0,
    tank_capacity2: 0,
    tank_ad_blue: 0,
    tank_lng: 0,
    tank_kwh: 0,
    vin: '',
    driver: null,
    device: { etoll: false },
    vars: {
      virtual_odometer: '',
      visible: '',
      icon_id: 0,
      name: '',
      phone: '',
      vehicle: null
    }
  }
}
type Icon = { id: number; src: string };

export default defineComponent({
  name: 'VehicleModal',
  components: {
    BaseModal,
    VueSelect
  },
  data() {
    return {
      vehicle: editVehicle(),
      drivers: [],
      selectedDriver: null,
      icons: [] as Icon[]
    }
  },
  setup() {
    return { v: useVuelidate() }
  },
  validations: {
    vehicle: {
      registration: { required },
      tank_capacity: {},
      tank_capacity2: {},
      tank_ad_blue: {},
      tank_lng: {},
      tank_kwh: {},
      vin: {},
      driver: {},
      vars: {
        virtual_odometer: {},
        name: {},
        phone: {}
      }
    }
  },
  methods: {
    loadIcons(): Icon[] {
      const iconsReq = require.context(
          '@/assets/img/map/icons',
          false,
          /\.png$/,
      );

      return iconsReq.keys()
          .map((file): Icon | null => {
            const m = file.match(/(\d+)\.png$/);
            if (!m) return null;
            return {
              id: Number(m[1]),
              src: (iconsReq(file) as any).default ?? iconsReq(file),
            };
          })
          .filter((icon): icon is Icon => icon !== null)
          .sort((a, b) => a.id - b.id);
    },
    getDriver(value): void {
      if (value) {
        this.vehicle.driver = value.id
      } else {
        this.vehicle.driver = null
      }
    },
    openEditModal(data) {
      const self: any = this
      if (data.driver)
        this.selectedDriver = data.driver

      if (data) Object.assign(this.vehicle, JSON.parse(JSON.stringify(data)))

      this.vehicle.device = this.vehicle.device || {}
      this.vehicle.device.etoll = !!this.vehicle.device.etoll

      this.v.$reset()
      self.$refs.core.openModal()
    },
    closeModal() {
      const self: any = this
      self.$refs.core.closeModal()
    },
    editVehicle() {
      this.v.$touch()
      if (!this.v.$invalid) {
        const self: any = this
        axiosInstance.patch(`/api/v1/vehicle_vars/${ self.vehicle.vars.id }`, this.vehicle.vars)
            .then(() => {
              delete self.vehicle.vars

              if (self.vehicle.device) {
                self.vehicle.device = { etoll: !!self.vehicle.device.etoll }
              }

              self.$emit('emittedRefreshGrid', true)
              axiosInstance.patch(`/api/v1/vehicle/${ self.vehicle.id }`, this.vehicle)
                  .then(() => {
                    if (self.vehicle.driver) {
                      self.vehicle.driver = self.vehicle.driver.id;
                    }
                    self.$toast.success(this.$t('components.vehicles.modals.successfullyEdited'))
                    self.$emit('emittedRefreshGrid', true)
                  })
                  .catch(() => {
                    self.$swal.fire({
                      icon: 'warning',
                      title: 'Oops...',
                      text: this.$t('components.error')
                    })
                  })
            })
            .catch(() => {
              self.$swal.fire({
                icon: 'warning',
                title: 'Oops...',
                text: this.$t('components.error')
              })
            })
        self.$refs.core.closeModal()
      }
    },
    fetchDrivers() {
      const self: any = this
      getUsers()
          .then(response => {
            while (this.drivers.length > 0) {
              this.drivers.pop()
            }
            response.data.data.result.forEach(function (obj) {
              self.drivers.push(obj)
            })
          })
          .catch(() => {
            self.$swal.fire({
              icon: 'warning',
              title: 'Oops...',
              text: this.$t('components.error')
            })
          })
    }
  },
  mounted() {
    this.icons = this.loadIcons();
    this.fetchDrivers()
  }
})
</script>

<style lang="scss">
label {
  display: block !important;
}

input[type="radio"] {
  margin: 5px 8px;
}
.icon-thumb {
  height: 42px;
  border-radius: 4px;
}

.icon-radio input:checked + .icon-thumb {
  outline: 3px solid #f67f01;
}
</style>